'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25633 9.17268C5.85256 8.79587 5.8307 8.16308 6.20751 7.75931L10.9364 2.69199C11.5209 2.06573 12.5135 2.06572 13.098 2.69198L17.7868 7.7162C18.1636 8.11997 18.1417 8.75276 17.738 9.12957C17.3342 9.50638 16.7014 9.48453 16.3246 9.08076L12.9963 5.51431L12.9963 16.112C12.9963 16.6643 12.5485 17.112 11.9963 17.112C11.444 17.112 10.9963 16.6643 10.9963 16.112L10.9963 5.55925L7.6697 9.12385C7.29289 9.52763 6.66011 9.54949 6.25633 9.17268ZM3.32621 14.128C3.32621 13.5757 2.87849 13.128 2.32621 13.128C1.77392 13.128 1.3262 13.5757 1.3262 14.128V15.4342V15.5065V15.5065C1.32617 17.1431 1.32615 18.4724 1.46701 19.5201C1.6138 20.6119 1.92986 21.5464 2.67417 22.2907C3.41847 23.035 4.35296 23.3511 5.44479 23.4979C6.49246 23.6387 7.82172 23.6387 9.45837 23.6387H9.53066H14.4705H14.5428C16.1794 23.6387 17.5087 23.6387 18.5564 23.4979C19.6482 23.3511 20.5827 23.035 21.327 22.2907C22.0713 21.5464 22.3874 20.6119 22.5342 19.5201C22.675 18.4724 22.675 17.1432 22.675 15.5065V15.4342V14.185C22.675 13.6327 22.2272 13.185 21.675 13.185C21.1227 13.185 20.675 13.6327 20.675 14.185V15.4342C20.675 17.1606 20.6728 18.3548 20.552 19.2536C20.435 20.1236 20.2235 20.5657 19.9128 20.8765C19.602 21.1872 19.1599 21.3987 18.2899 21.5157C17.3911 21.6365 16.1969 21.6387 14.4705 21.6387H9.53066C7.80428 21.6387 6.6101 21.6365 5.71128 21.5157C4.84124 21.3987 4.39914 21.1872 4.08838 20.8765C3.77761 20.5657 3.56615 20.1236 3.44917 19.2536C3.32833 18.3548 3.32621 17.1606 3.32621 15.4342V14.128Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
